<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                auditorForm: () => import('../forms/AuditorForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [], form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'autocomplete', text: 'Auditor', value: 'auditorId', rules: [], form: () => import('./AuditorForm'), apiMethod: 'Auditors', claim: 'Auditors' },
                    { type: 'text', text: 'Email Address', value: 'emailAddress', rules: [v => !!v || 'Email Address is required', v => !(v && v.length > 320) || 'Email Address must be less than 320 characters'], isRequired: true, maxLength: 320 },
                    { type: 'checkbox', text: 'Is Email Confirmed', value: 'isEmailConfirmed', rules: [v => (v !== null && v !== '') || 'Is Email Confirmed is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Inactive', value: 'isInactive', rules: [v => (v !== null && v !== '') || 'Is Inactive is required'], isRequired: true },
                ],
                apiMethod: 'Users',
                formTitle: 'User',
            }
        },
    };
</script>
